import { render, staticRenderFns } from "./AddInterview.vue?vue&type=template&id=20feb310"
import script from "./AddInterview.vue?vue&type=script&lang=js"
export * from "./AddInterview.vue?vue&type=script&lang=js"
import style0 from "./AddInterview.vue?vue&type=style&index=0&id=20feb310&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports